const commentsData = [
  {
    author: 'Milo Styles',
    id: '1',
    date: new Date(),
    content:
      'Percolator cup medium, organic doppio acerbic wings rich french press. Galão, brewed cultivar dark filter redeye medium mazagran. That and milk black, dripper, kopi-luwak, cup chicory shop extra viennese.',
  },
  {
    author: 'Jane Styles',
    id: '2',
    date: new Date(),
    content:
      'Percolator cup medium, organic doppio acerbic wings rich french press. Galão, brewed cultivar dark filter redeye medium mazagran. That and milk black, dripper, kopi-luwak, cup chicory shop extra viennese.',
  },
  {
    author: 'Sven Torpe',
    id: '3',
    date: new Date(),
    content:
      'Percolator cup medium, organic doppio acerbic wings rich french press. Galão, brewed cultivar dark filter redeye medium mazagran. That and milk black, dripper, kopi-luwak, cup chicory shop extra viennese.',
  },
];

export default commentsData;
